export default __webpack_public_path__ + "media/images/corporate/apartments/second_slide_md-6a4b85cd4598e8d34b952e2d02849ceb.png";